module.exports = __webpack_public_path__ + "static/media/bible-logo-white.7069b5cd.svg";